import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { LoadGeneralComponent } from '../../shared/components-generals/load-general/load-general.component';
import { MatTableDataSource } from '@angular/material/table';
import { InputSelect } from '../../shared/models/pages-model/form-general.model';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TableGeneralComponent } from '../../shared/components-generals/table-general/table-general.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-services-table',
  standalone: true,
  imports: [
    TableGeneralComponent,
    MatPaginator,
    LoadGeneralComponent,
    MatButtonModule,
    MatIcon,
    TranslateModule,
  ],
  templateUrl: './services-table.html',
  styleUrl: './services-table.css',
})
export class ServicesTable {
  public loadService = false;
  public pageIndex = 1;
  public dataSource = new MatTableDataSource<any>([]);
  public dataSourceOrigen: any[] = [];
  public headers: InputSelect[] = [
    { value: 'id', description: 'ID Aux' },
    { value: 'service', description: 'Servicio' },
    { value: 'status', description: 'Estatus' },
    { value: 'fecha', description: 'Fecha' },
  ];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ServicesTable>,
    @Inject(MAT_DIALOG_DATA) public data: { id: number },
  ) {
    this.dataSourceOrigen = [
      { service: 'Servicio 1', status: 'Activo', fecha: '01/01/2024', id: 1 },
      { service: 'Servicio 2', status: 'Inactivo', fecha: '02/01/2024', id: 2 },
      { service: 'Servicio 3', status: 'Activo', fecha: '03/01/2024', id: 3 },
      { service: 'Servicio 4', status: 'Inactivo', fecha: '04/01/2024', id: 4 },
      { service: 'Servicio 5', status: 'Activo', fecha: '05/01/2024', id: 5 },
      { service: 'Servicio 6', status: 'Inactivo', fecha: '06/01/2024', id: 6 },
      { service: 'Servicio 7', status: 'Activo', fecha: '07/01/2024', id: 7 },
      { service: 'Servicio 8', status: 'Inactivo', fecha: '08/01/2024', id: 8 },
      { service: 'Servicio 9', status: 'Activo', fecha: '09/01/2024', id: 9 },
      { service: 'Servicio 10', status: 'Inactivo', fecha: '10/01/2024', id: 10 },
      { service: 'Servicio 11', status: 'Activo', fecha: '11/01/2024', id: 11 },
      { service: 'Servicio 12', status: 'Inactivo', fecha: '12/01/2024', id: 12 },
      { service: 'Servicio 13', status: 'Activo', fecha: '13/01/2024', id: 13 },
      { service: 'Servicio 14', status: 'Inactivo', fecha: '14/01/2024', id: 14 },
      { service: 'Servicio 15', status: 'Activo', fecha: '15/01/2024', id: 15 },
      { service: 'Servicio 16', status: 'Inactivo', fecha: '16/01/2024', id: 16 },
      { service: 'Servicio 17', status: 'Activo', fecha: '17/01/2024', id: 17 },
      { service: 'Servicio 18', status: 'Inactivo', fecha: '18/01/2024', id: 18 },
      { service: 'Servicio 19', status: 'Activo', fecha: '19/01/2024', id: 19 },
      { service: 'Servicio 20', status: 'Inactivo', fecha: '20/01/2024', id: 20 },
    ];

    this.dataSource = new MatTableDataSource<any>(this.dataSourceOrigen.slice(0, 10));
  }

  public closeModal(): void {
    this.dialogRef.close(null);
  }

  public onPageChange(event: any): void {
    this.pageIndex = event + 1;
    this.dataSource = new MatTableDataSource<any>(
      this.dataSourceOrigen.slice((this.pageIndex - 1) * 10, this.pageIndex * 10),
    );
  }
}
